webpackJsonp([55],{

/***/ "./node_modules/event-widgets/lib/EventFooter/EventFooterWidget.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _FooterWidget = __webpack_require__("./node_modules/nucleus-widgets/lib/Footer/FooterWidget.js");

var _FooterWidget2 = _interopRequireDefault(_FooterWidget);

var _reactRedux = __webpack_require__("./node_modules/react-redux/es/index.js");

var _privacyPolicyUtils = __webpack_require__("./node_modules/event-widgets/utils/privacyPolicyUtils.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getPrivacyPolicyLinks(state, config) {
  var links = [];

  if (config.cventPrivacyPolicy.visible) {
    links.push({
      url: (0, _privacyPolicyUtils.getPrivacyPolicyLink)(state.event.languageId || state.event.cultureCode),
      text: config.cventPrivacyPolicy.text
    });
  }

  if (config.plannerPrivacyPolicy.visible) {
    links.push({
      url: config.plannerPrivacyPolicy.url,
      text: config.plannerPrivacyPolicy.text
    });
  }

  return links;
}

/* Data wrapper for the footer widget */
exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    allowCustomFooter: state.account.settings.allowCustomEventFooter,
    showPrivacyPolicy: false,
    additionalPolicyLinks: getPrivacyPolicyLinks(state, state.website.layoutItems.CventFooterSection.config)
  };
})(_FooterWidget2.default);

/***/ }),

/***/ "./node_modules/nucleus-widgets/lib/Footer/CustomFooter.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _nucleusDynamicCss = __webpack_require__("./node_modules/@cvent/nucleus-dynamic-css/lib/es/index.js");

var _nucleusTestAutomation = __webpack_require__("./node_modules/@cvent/nucleus-test-automation/lib/es/index.js");

var _CustomFooter = __webpack_require__("./node_modules/nucleus-widgets/lib/Footer/CustomFooter.less");

var _CustomFooter2 = _interopRequireDefault(_CustomFooter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

/* eslint-disable no-script-url */
var noOp = 'javascript:void(0);';

/**
 * A component that display the custom footer content.
 */

var CustomFooter = function (_React$Component) {
  _inherits(CustomFooter, _React$Component);

  function CustomFooter() {
    var _temp, _this, _ret;

    _classCallCheck(this, CustomFooter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.getHrefValue = function (href) {
      return _this.props.enableHyperlink ? href : noOp;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  CustomFooter.prototype.renderPrivacyPolicyLink = function renderPrivacyPolicyLink() {
    return _react2.default.createElement(
      'li',
      _extends({ key: 'privacyPolicy' }, (0, _nucleusDynamicCss.resolve)(this.props, 'list')),
      _react2.default.createElement(
        'a',
        _extends({}, (0, _nucleusDynamicCss.resolve)(this.props, 'link'), {
          href: this.getHrefValue(this.props.privacyPolicyUrl),
          target: '_blank' }),
        this.props.translate('_cventFooter_privacyPolicy__resx')
      )
    );
  };

  CustomFooter.prototype.renderLink = function renderLink(href, text, key) {
    return _react2.default.createElement(
      'li',
      _extends({}, (0, _nucleusDynamicCss.resolve)(this.props, 'list'), { key: key }),
      _react2.default.createElement(
        'a',
        _extends({}, (0, _nucleusDynamicCss.resolve)(this.props, 'link'), { href: this.getHrefValue(href), target: '_blank' }),
        this.props.translate(text)
      )
    );
  };

  CustomFooter.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        showPrivacyPolicy = _props.showPrivacyPolicy,
        additionalPolicyLinks = _props.additionalPolicyLinks;


    return _react2.default.createElement(
      'footer',
      _extends({}, (0, _nucleusTestAutomation.resolveTestId)(this.props), (0, _nucleusDynamicCss.resolve)(this.props, 'container')),
      _react2.default.createElement(
        'ul',
        (0, _nucleusDynamicCss.resolve)(this.props, 'policyLinks'),
        [showPrivacyPolicy && this.renderPrivacyPolicyLink()].concat(additionalPolicyLinks && additionalPolicyLinks.length >= 1 && additionalPolicyLinks.map(function (link, index) {
          return _this2.renderLink(link.url, link.text, 'policyLink' + index);
        }))
      )
    );
  };

  return CustomFooter;
}(_react2.default.Component);

CustomFooter.displayName = 'CustomFooter';
CustomFooter.defaultProps = {
  classes: _CustomFooter2.default,
  privacyPolicyUrl: 'https://www.cvent.com/en/privacy-policy.shtml',
  showPrivacyPolicy: true
};
exports.default = CustomFooter;
CustomFooter.propTypes =  false ? {
  /* translate text resolver for text */
  translate: _propTypes2.default.func,
  /* whether the links are clickable */
  enableHyperlink: _propTypes2.default.bool,
  /* whether to display default privacy policy URL */
  showPrivacyPolicy: _propTypes2.default.bool,
  /* custom privacy policy URL */
  privacyPolicyUrl: _propTypes2.default.string,
  /* additional links */
  additionalPolicyLinks: _propTypes2.default.array
} : {};

/***/ }),

/***/ "./node_modules/nucleus-widgets/lib/Footer/CustomFooter.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"CustomFooter__container___2jzEf","cventLinks":"CustomFooter__cventLinks___2wbWL","policyLinks":"CustomFooter__policyLinks___1H8JA","list":"CustomFooter__list___nNIEk","link":"CustomFooter__link___2nSUw"};

/***/ }),

/***/ "./node_modules/nucleus-widgets/lib/Footer/Footer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _nucleusDynamicCss = __webpack_require__("./node_modules/@cvent/nucleus-dynamic-css/lib/es/index.js");

var _nucleusTestAutomation = __webpack_require__("./node_modules/@cvent/nucleus-test-automation/lib/es/index.js");

var _Footer = __webpack_require__("./node_modules/nucleus-widgets/lib/Footer/Footer.less");

var _Footer2 = _interopRequireDefault(_Footer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

/* eslint-disable no-script-url */
var noOp = 'javascript:void(0);';

/**
 * A component that display the cvent's footer content.
 */

var Footer = function (_React$Component) {
  _inherits(Footer, _React$Component);

  function Footer() {
    var _temp, _this, _ret;

    _classCallCheck(this, Footer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.getHrefValue = function (href) {
      return _this.props.enableHyperlink ? href : noOp;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Footer.prototype.renderLogo = function renderLogo() {
    return _react2.default.createElement(
      'a',
      _extends({}, (0, _nucleusDynamicCss.resolve)(this.props, 'logoImage'), {
        href: this.getHrefValue('http://www.cvent.com/'),
        target: '_blank'
      }),
      'Cvent'
    );
  };

  Footer.prototype.renderLink = function renderLink(href, localizationString) {
    // NOTE using localizationString as key under the assumption that they are all unique.
    return _react2.default.createElement(
      'li',
      _extends({}, (0, _nucleusDynamicCss.resolve)(this.props, 'list'), { key: localizationString }),
      _react2.default.createElement(
        'a',
        _extends({}, (0, _nucleusDynamicCss.resolve)(this.props, 'link'), { href: this.getHrefValue(href), target: '_blank' }),
        this.props.translate(localizationString)
      )
    );
  };

  Footer.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        translate = _props.translate,
        showCventLogo = _props.showCventLogo,
        showCopyrightInformation = _props.showCopyrightInformation,
        showEventManagementSoftware = _props.showEventManagementSoftware,
        showMobileEventApps = _props.showMobileEventApps,
        showInquisium = _props.showInquisium,
        showEventVenues = _props.showEventVenues,
        showStrategicMeetingsManagement = _props.showStrategicMeetingsManagement,
        showPrivacyPolicy = _props.showPrivacyPolicy,
        showTermsOfUse = _props.showTermsOfUse,
        additionalPolicyLinks = _props.additionalPolicyLinks,
        privacyPolicyUrl = _props.privacyPolicyUrl;


    return _react2.default.createElement(
      'footer',
      _extends({}, (0, _nucleusTestAutomation.resolveTestId)(this.props), (0, _nucleusDynamicCss.resolve)(this.props, 'container')),
      showCventLogo && this.renderLogo(),
      showCopyrightInformation && _react2.default.createElement(
        'span',
        (0, _nucleusDynamicCss.resolve)(this.props, 'copyright'),
        translate('GuestWebsite_Footer_Copyright__resx')
      ),
      _react2.default.createElement(
        'ul',
        (0, _nucleusDynamicCss.resolve)(this.props, 'marketingLinks'),
        [showEventManagementSoftware && this.renderLink('http://www.cvent.com/en/event-management-software/', '_cventFooter_eventManagementSoftware__resx'), showMobileEventApps && this.renderLink('http://www.cvent.com/en/mobile-event-apps/', '_cventFooter_mobileEventApps__resx'), showInquisium && this.renderLink('http://www.inquisium.com/', '_cventFooter_surveySoftware__resx'), showEventVenues && this.renderLink('http://www.cvent.com/rfp/hotels', '_cventFooter_eventVenues__resx'), showStrategicMeetingsManagement && this.renderLink('http://www.cvent.com/en/strategic-meetings-management/', '_cventFooter_strategicMeetingsManagement__resx')]
      ),
      _react2.default.createElement(
        'ul',
        (0, _nucleusDynamicCss.resolve)(this.props, 'policyLinks'),
        [showTermsOfUse && this.renderLink('http://www.cvent.com/en/eula.shtml', '_cventFooter_endUserLicenceAgreement__resx'), showPrivacyPolicy && this.renderLink(privacyPolicyUrl, '_cventFooter_privacyPolicy__resx')].concat(additionalPolicyLinks && additionalPolicyLinks.length >= 1 && additionalPolicyLinks.map(function (link) {
          return _this2.renderLink(link.url, link.text);
        }))
      )
    );
  };

  return Footer;
}(_react2.default.Component);

Footer.displayName = 'Footer';
Footer.defaultProps = {
  classes: _Footer2.default,
  privacyPolicyUrl: 'https://www.cvent.com/en/privacy-policy.shtml'
};
exports.default = Footer;
Footer.propTypes =  false ? {
  /* translate text resolver for text */
  translate: _propTypes2.default.func,
  /* whether to display the cvent logo or not */
  showCventLogo: _propTypes2.default.bool,
  /* whether to display copyright information */
  showCopyrightInformation: _propTypes2.default.bool,
  /* whether to display Event Management Software link */
  showEventManagementSoftware: _propTypes2.default.bool,
  /* whether to display Mobile Event Apps link */
  showMobileEventApps: _propTypes2.default.bool,
  /* whether to display Inquisium link */
  showInquisium: _propTypes2.default.bool,
  /* whether to display Event Venues link */
  showEventVenues: _propTypes2.default.bool,
  /* whether to display Strategic Meetings Management link */
  showStrategicMeetingsManagement: _propTypes2.default.bool,
  /* whether to display privacy policy link */
  showPrivacyPolicy: _propTypes2.default.bool,
  /* whether the links are clickable */
  enableHyperlink: _propTypes2.default.bool,
  /* whether to display terms of use (end user license agreement) link */
  showTermsOfUse: _propTypes2.default.bool,
  /* display extra policy links */
  additionalPolicyLinks: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    text: _propTypes2.default.string.isRequired,
    url: _propTypes2.default.string.isRequired
  })),
  /* custom privacy policy URL */
  privacyPolicyUrl: _propTypes2.default.string
} : {};

/***/ }),

/***/ "./node_modules/nucleus-widgets/lib/Footer/Footer.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"Footer__container___GmT_B","cventLinks":"Footer__cventLinks___2cfWa","marketingLinks":"Footer__marketingLinks___1v5pr","policyLinks":"Footer__policyLinks___3nbZ_","list":"Footer__list___3q1As","link":"Footer__link___1JkvQ","copyright":"Footer__copyright___2Bdpv","logoImage":"Footer__logoImage___2Voeq"};

/***/ }),

/***/ "./node_modules/nucleus-widgets/lib/Footer/FooterWidget.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _BaseWidget2 = __webpack_require__("./node_modules/nucleus-widgets/lib/BaseWidget.js");

var _BaseWidget3 = _interopRequireDefault(_BaseWidget2);

var _Footer = __webpack_require__("./node_modules/nucleus-widgets/lib/Footer/Footer.js");

var _Footer2 = _interopRequireDefault(_Footer);

var _CustomFooter = __webpack_require__("./node_modules/nucleus-widgets/lib/Footer/CustomFooter.js");

var _CustomFooter2 = _interopRequireDefault(_CustomFooter);

var _nucleusTestAutomation = __webpack_require__("./node_modules/@cvent/nucleus-test-automation/lib/es/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

/**
 * Data wrapper for the event footer widget.
 */
var FooterWidget = function (_BaseWidget) {
  _inherits(FooterWidget, _BaseWidget);

  function FooterWidget() {
    _classCallCheck(this, FooterWidget);

    return _possibleConstructorReturn(this, _BaseWidget.apply(this, arguments));
  }

  FooterWidget.prototype.getStyleObject = function getStyleObject() {
    var links = this.getElementInlineStyle('links');
    return _extends({}, _BaseWidget.prototype.getStyleObject.call(this), {
      link: links,
      copyright: this.getElementInlineStyle('copyright'),
      list: {
        borderColor: links.color
      }
    });
  };

  FooterWidget.prototype.render = function render() {
    if (this.props.allowCustomFooter) {
      return _react2.default.createElement(_CustomFooter2.default, _extends({}, (0, _nucleusTestAutomation.resolveTestId)(this.props), this.props, {
        style: this.getStyleObject() }));
    }
    return _react2.default.createElement(_Footer2.default, _extends({}, (0, _nucleusTestAutomation.resolveTestId)(this.props), this.props, {
      style: this.getStyleObject() }));
  };

  return FooterWidget;
}(_BaseWidget3.default);

FooterWidget.displayName = 'FooterWidget';
FooterWidget.propTypes = {
  /* Application specific classes for the footer */
  classes: _propTypes2.default.object,
  /* Available style keys */
  style: _propTypes2.default.shape({
    footerContainer: _propTypes2.default.object,
    list: _propTypes2.default.object,
    link: _propTypes2.default.object,
    marketingLinks: _propTypes2.default.object,
    policyLinks: _propTypes2.default.object
  }),
  /* translate text resolver for text */
  translate: _propTypes2.default.func,
  // Non-configurable props that should be passed in by the application specific wrapper.
  /* whether to display the cvent logo or not */
  showCventLogo: _propTypes2.default.bool,
  /* whether to display copyright information */
  showCopyrightInformation: _propTypes2.default.bool,
  /* whether to display Event Management Software link */
  showEventManagementSoftware: _propTypes2.default.bool,
  /* whether to display Mobile Event Apps link */
  showMobileEventApps: _propTypes2.default.bool,
  /* whether to display Inquisium link */
  showInquisium: _propTypes2.default.bool,
  /* whether to display Event Venues link */
  showEventVenues: _propTypes2.default.bool,
  /* whether to display Strategic Meetings Management link */
  showStrategicMeetingsManagement: _propTypes2.default.bool,
  /* whether to display privacy policy link */
  showPrivacyPolicy: _propTypes2.default.bool,
  /* whether the links are clickable */
  enableHyperlink: _propTypes2.default.bool,
  /* account settings to show or hide custom footer*/
  allowCustomFooter: _propTypes2.default.bool,
  /* display extra policy links */
  additionalPolicyLinks: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    text: _propTypes2.default.string.isRequired,
    url: _propTypes2.default.string.isRequired
  })),
  /* custom privacy policy URL */
  privacyPolicyUrl: _propTypes2.default.string
};
FooterWidget.defaultProps = {
  showCventLogo: true,
  showCopyrightInformation: true,
  showEventManagementSoftware: true,
  showMobileEventApps: true,
  showInquisium: true,
  showEventVenues: true,
  showStrategicMeetingsManagement: true,
  showPrivacyPolicy: true,
  enableHyperlink: true,
  showTermsOfUse: false,
  allowCustomFooter: false,
  privacyPolicyUrl: 'https://www.cvent.com/en/privacy-policy.shtml'
};
exports.default = FooterWidget;

/***/ })

});


// WEBPACK FOOTER //
// 55.prod._v4.7a9e0280f0ea3f3d47b4.js